export default __webpack_public_path__ + "static/media/audio_19_camotero.600bf246.mp3";